module.exports = __webpack_public_path__ + "media/lizi.94716eeb.mp4";